<template>
    <span @click.stop.prevent="startTour" class="cursor-pointer inline-block">
        <slot>
            <q-icon name="help_outline" size="sm" color="primary" />
        </slot>
    </span>
</template>

<script>
import { onMounted, ref } from "vue";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import axios from "axios";

export default {
    name: "CoachMarksTour",
    props: {
        tourKey: { type: String, required: true },
        steps: { type: Array, required: true },
        hasSeen: { type: Boolean, default: false },
        autoOpen: { type: Boolean, default: true },
    },
    setup(props) {
        const isCompleted = ref(props.hasSeen);

        const startTour = () => {
            const driverObj = driver({
                showProgress: true,
                nextBtnText: window.translations?.next || "Next",
                prevBtnText: window.translations?.previous || "Previous",
                doneBtnText: window.translations?.done || "Done",
                progressText:
                    window.translations?.progress || "{{current}} of {{total}}",
                steps: props.steps,
                onDestroyStarted: () => {
                    if (
                        !driverObj.hasNextStep() ||
                        confirm("Are you sure you want to skip the tour?")
                    ) {
                        driverObj.destroy();
                        markAsSeen();
                    }
                },
            });
            driverObj.drive();
        };

        const markAsSeen = () => {
            if (!isCompleted.value) {
                axios
                    .post("/api/user/tours", { tour_key: props.tourKey })
                    .then(() => (isCompleted.value = true))
                    .catch((err) =>
                        console.error("Failed to save tour status", err),
                    );
            }
        };

        onMounted(() => {
            if (!isCompleted.value || !props.autoOpen) {
                setTimeout(startTour, 500);
            }
        });

        return { startTour };
    },
};
</script>
